import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
// import { event } from "jquery";
// config
import configData from "../../../config/config.json";
// components
import AlertSuccess from "../../AlertSuccess/AlertSuccess";
import AlertError from "../../AlertError/AlertError";

const InformationStep3 = () => {
  const [dataCome, setDataCome] = useState(false);
  const [disable, setDisable] = useState(false);

  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  const [data, setData] = useState("");
  const [Endata, setEnData] = useState("");

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setDataCome(false);
    axios
      .get(
        configData.API_DOMAIN + `/api/v1/Businesses/${getCookie("BizUuid")}`,
        {
          headers: header,
        }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          let data = response.data.data;

          // set data to states
          setData(data.description);
          setEnData(data.origDescription);
          setDataCome(true);
        }
      })
      .catch((error) => {
        // alert(error);
      });

    // load api by aidin
    // axios
    //   .get(domain + "/api/biz/description", {
    //     headers: header,
    //   })
    //   .then((response) => {
    //     if (response.data.msg == "done") {
    //       setData(response.data.Description);
    //       setEnData(response.data.EnDescription);
    //       setDataCome(true);
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
  }, []);

  const [errorAlert, setErrorAlert] = useState(null);
  const errorAlertHandeler = (lang) => {
    setErrorAlert(lang);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setErrorAlert(null);
    }, 4000);
  };

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    const dataPost = {
      bId: getCookie("BizId"),
      description: data,
      enDescription: Endata,
    };

    axios
      .patch(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/description`,
        dataPost,
        {
          headers: header,
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // success
          alertHandeler();
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  return (
    <>
      <div className="part_three_info">
        <div>
          {dataCome ? (
            <>
              <p className="eng-per-title text-start mt-0">English</p>

              <textarea
                value={Endata}
                dir="ltr"
                onChange={(event) => {
                  setEnData(
                    event.target.value.replace(/[^A-Za-z0-9\s,]/gi, "")
                  );
                  // Validate input to allow only English characters, numbers, and spaces
                  if (!/^[a-zA-Z0-9 ]*$/.test(event.target.value)) {
                    errorAlertHandeler("انگلیسی");
                  }
                }}
                className="textArea_info font-family-en"
                name=""
                id=""
                cols="30"
                rows="10"
                placeholder="English Description"
              ></textarea>

              <p className="eng-per-title text-end mt-0">فارسی</p>
              <textarea
                value={data}
                onChange={(event) => setData(event.target.value)}
                className="textArea_info"
                name=""
                id=""
                cols="30"
                rows="10"
                placeholder="توضیحات به فارسی"
              ></textarea>
            </>
          ) : (
            <Skeleton
              className="textArea_info border-0 mb-1"
              variant="rectangular"
              // height={107}
              animation="wave"
            />
          )}
        </div>
        <div className=" step2_save_c">
          {dataCome ? (
            <button
              onClick={submitHandler}
              disabled={disable}
              className="btn_information_submit"
            >
              ذخیره اطلاعات
            </button>
          ) : (
            <Skeleton
              className="btn_information_submit me-auto"
              variant="rectangular"
              height={39}
              animation="wave"
            />
          )}
        </div>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={" اطلاعات شما با موفقیت ثبت شد."}
        />
      </div>
      {/* alert error */}
      <AlertError
        showAlert={errorAlert}
        text={`زبان کیبورد را به ${errorAlert} تغییر دهید.`}
      />
    </>
  );
};

export default InformationStep3;
